const TONES = {
  chime: [[880, 0, 0.25], [1318.5, 0.12, 0.35]],
  bell: [[659.3, 0, 0.6], [1318.5, 0, 0.4]],
  coin: [[987.8, 0, 0.08], [1318.5, 0.08, 0.3]],
  ping: [[1567.98, 0, 0.18]],
};

export const BUILTIN_SOUNDS = ["chime", "bell", "coin", "ping"];
export const DEFAULT_PREFS = { order: "chime", message: "ping", volume: 0.7 };

let ctx;
function synth(tones, volume) {
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  const now = ctx.currentTime;
  tones.forEach(([freq, start, dur]) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, now + start);
    gain.gain.exponentialRampToValueAtTime(0.4 * volume + 0.0001, now + start + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
    osc.connect(gain).connect(ctx.destination);
    osc.start(now + start);
    osc.stop(now + start + dur + 0.05);
  });
}

export function playSound(key, volume = 0.7) {
  if (!key || key === "off" || volume <= 0) return;
  try {
    if (key.startsWith("custom:")) {
      const audio = new Audio(`${process.env.REACT_APP_BACKEND_URL}/api/sounds/${key.slice(7)}/file`);
      audio.volume = volume;
      audio.play().catch(() => {});
    } else if (TONES[key]) {
      synth(TONES[key], volume);
    }
  } catch (e) { /* browser blocked audio */ }
}
